// Module
var code = "<section role=\"alert\" aria-live><p translate=\"activity-editor-master-activity-help\"></p><a class=\"tertiary-btn light\" ng-href=\"{{$ctrl.data.linkUrl}}\" target=\"_blank\" translate=\"common_more-info-capitalized\"></a></section>";
// Exports
module.exports = code;